<script setup lang="ts">
import { Form, Field, ErrorMessage } from 'vee-validate';
import { object, string } from 'yup';

const emit = defineEmits<{ (event: 'nextStep', value: 'success'): void }>();
const { validateFaChar ,validateMobile, numberOnly, pasteNumber }  = useInputHelpers();
const { post, loading } = useSendMail();
const userInfo = ref({
    firstname: '',
    name: '',
    number: '',
    desc: ''
});
const schema = object({
    name: string()
        .required("این فیلد نباید خالی باشد.")
        .test("", "مقدار وارد شده معتبر نیست.", validateFaChar),
    number: string()
        .required("این فیلد نباید خالی باشد.")
        .test("", "مقدار وارد شده معتبر نیست.", validateMobile),
});

async function onSubmit() {
    const { data, error } = await post({ body: { model: userInfo.value } }) as any;
    if (!error.value && data.value === 'ok')
        emit('nextStep', 'success');
};
function handleOnCall() {
    window.location.href = 'tel:02182800000';
};
</script>

<template>
    <div class="w-full">
        <p class="text-body2-bold md:text-[1rem]! text-center mb-3 lg:mb-5 lg:mt-3">
            لطفا فرم زیر را تکمیل کنید تا در یک تماس تلفنی، درباره راهکارهای بهبود کسب‌و‌کار شما صحبت کنیم.
        </p>

        <div class="flex flex-col">
            <Form
                :validationSchema="schema"
                :initialValues="userInfo"
                v-slot="{ handleSubmit, errors }"
            >
                <div class="w-full grid grid-cols-2 md:grid-cols-3 gap-x-3 gap-y-2 md:gap-x-5">
                    <div>
                        <label>نام</label>
                        <Field name="firstname" placeholder="وارد کنید" v-model="userInfo.firstname" />
                    </div>
                    <div>
                        <label>نام خانوادگی</label>
                        <Field 
                            name="name" 
                            placeholder="وارد کنید" 
                            required
                            :class="errors.name && 'error'"
                            v-model="userInfo.name"
                        />
                        <ErrorMessage name="name" />
                    </div>
                    <div class="col-span-2 md:col-span-1">
                        <label>شماره تماس</label>
                        <Field 
                            name="number" 
                            placeholder="وارد کنید"
                            :class="errors.number && 'error'"
                            @keypress="numberOnly"
                            @paste="pasteNumber"
                            required
                            v-model="userInfo.number"
                        />
                        <ErrorMessage name="number" />
                    </div>
                    <div class="col-span-2 md:col-span-3">
                        <label>توضیحات</label>
                        <Field as="textarea" name="desc" placeholder="متن را وارد کنید" v-model="userInfo.desc" />
                    </div>
                </div>
                <div class="flex flex-col lg:flex-row items-center justify-between mt-2 lg:mt-4">
                    <div class="w-full lg:w-2/3 flex items-center justify-between lg:justify-start lg:gap-2 order-2 lg:order-1">
                        <div class="flex items-center gap-1 lg:gap-2 relative">
                            <div class="w-1.5 h-1.5 rounded-full bg-success-600 absolute bottom-0.5 right-0.5" />
                            <div class="rounded-full w-8 lg:w-10 aspect-square flex-center overflow-hidden border border-gray-200">
                                <img 
                                    src="/img/new/cta-01.webp"
                                    alt="نواتل"
                                    class="h-full max-w-fit!"
                                />
                            </div>
                            <span class="text-caption lg:text-[.875rem]! text-gray-500">همین حالا با ما تماس بگیرید.</span>                    
                        </div>
                        <div class="flex items-center">
                            <Button
                                type="Thirdly"
                                size="Large"
                                :appendIcon="{ name: 'solar:phone-rounded-linear'}"
                                @click.prevent="handleOnCall"
                                class="phone-ringing p-0! [&>.btn-slot-parent]:gap-0"
                            >
                                02182800000
                            </Button>
                        </div>
                    </div>
                    <Button
                        :appendIcon="{ name: 'solar:round-arrow-left-bold' }"
                        class="order-1 lg:order-2"
                        size="Large"
                        :loading="loading"
                        pill
                        @click.prevent="handleSubmit(onSubmit)"
                    >
                        رزرو مشاوره رایگان
                    </Button>
                </div>
            </Form>
        </div>
    </div>
</template>

<style scoped>
@reference "~/assets/css/main.css";

:deep(.phone-ringing .iconify) {
    @apply
    animate-phone-ring
}
</style>